<template>
  <v-app>
    <div class="page-root">
      <!-- header -->
      <AppHeader />
      <!--body-->
      <v-container class="wrapper pa-0">
        <v-card class="card ma-0 pa-0">
          <v-row class="ma-0 pa-0 align-center" style="height: 100%;">
            <v-col cols="12" sm="6" class="pa-8">
              <BusinessInfoForm
                @hasName-value="handleEvent"
                @hasType-value="handleEvent"
                @hasFinancialYear-value="handleEvent"
                @next-step="changeStep"
                @previous-step="changeStep"
                @build-step="changeStep"
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-3 d-none d-sm-flex" style="height: 100%;">
              <BusinessStepper ref="stepper" class="login-side-image" />
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      <!-- footer -->
      <AppFooter />
    </div>
  </v-app>
</template>

<script>
import BusinessInfoForm from '@/views/dashboard/pages/business-info/partial/BusinessInfoForm.vue'
import AppHeader from '@/views/dashboard/pages/business-info/partial/AppHeader.vue'
import BusinessStepper from '@/views/dashboard/pages/business-info/partial/BusinessStepper.vue'
import AppFooter from '@/views/dashboard/pages/business-info/partial/Footer.vue'

export default {
  name: 'BusinessPage',
  components: {
    BusinessInfoForm,
    AppHeader,
    BusinessStepper,
    AppFooter
  },
  data: () => ({}),
  methods: {
    handleEvent (val) {
      // console.log(val.number);
      const Number = val.number
      if (val.flag) {
        this.$refs.stepper.handleProgressStep(Number)
      } else {
        this.$refs.stepper.decreaseProgressStep(Number)
      }
    },
    changeStep (val) {
      const Number = val.number
      const Flag = val.flag
      this.$refs.stepper.handleProgressStep(Number)
      if (!Flag) {
        this.$refs.stepper.previousStep()
      } else {
        this.$refs.stepper.completeStep()
      }
    }
  }
}
</script>

<style scoped>
.page-root {
  height: 100vh;
  position: relative;
}
.page-root .wrapper {
  top: 61px;
  position: absolute;
  bottom: 27.25px;
}
.page-root .card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  max-width: 1000px;
  height: 615px;
  display: flex;
  align-items: center;
}
.page-root .card .img-login {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 4px;
  background-size: cover;
}
::v-deep .page-root .card::-webkit-scrollbar {
  display: none;
}
@media (max-width: 580px) {
  .page-root .wrapper {
    top: 53px;
    bottom: 28.25px;
  }
}
</style>
